module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_symbol-69c39eb700241f543beb47aae8c16a09.svg";